<template>
    <ModalFormCard :submittedCallback="submittedCallback" 
        :action="'/upload/' + editingModel.id" class="modal-default"
        :toast='"File deleted"'
    >
        <template #title>Delete file</template>

        <template #default="{ saving, errors }">
            <input name="_method" type="hidden" value="DELETE" />

            <p class="text-15">Are you sure you want to delete "{{ editingModel.name }}"?</p>
            <p class="text-15 pt-2">This item will be deleted immediately, you can't undo this action.</p>

            <div class="grid grid-cols-4 pt-7 gap-4">
                <ButtonSaving :disabled="saving" class="button-black h-12 col-span-2"> Delete file </ButtonSaving>

                <button class="button-black-outline h-12 col-span-2" type="button" @click="$emit('close')">Cancel</button>
            </div>
        </template>
    </ModalFormCard>
</template>

<script>
import Modal from '~/mixins/modal.js'

export default {
    mixins: [Modal],

    methods: {
        submittedCallback(res) {
            // console.log("submittedCallback");
            // this.$event.$emit("upload-folder-deleted", res);
            this.$event.$emit('modal-form-completed')
            this.$event.$emit('modal-close')
        },
    },
}
</script>
